import { setInternalServerError } from '../../shared/scripts';

class Request {
    /**
    * @summary Read
    */
    static async get(uri) {
        try {
            const response = await fetch(uri);
            return await response.json();
        } catch (error) {
            setInternalServerError(error);
        }
    }

    /**
     * @summary Create
     */
    static async post(body, uri, zip = false) {
        return zip
            ? this.commonZipped(body, uri, 'post')
            : this.common(body, uri, 'post');
    }

    /**
    * @summary Update
    */
    static async put(body, uri) {
        return this.common(body, uri, 'put');
    }

    static async delete(body, uri) {
        return this.common(body, uri, 'delete');
    }


    static async common(bodyObj, uri, type) {
        try {
            const response = await fetch(
                uri,
                {
                    method: type,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(bodyObj),
                }
            );
            return await response.json();
        } catch (error) {
            setInternalServerError(error);
        }
    }

    static async commonZipped(bodyObj, uri, type) {
        try {
            const response = await fetch(
                uri,
                {
                    method: type,
                    body: await this.zip(
                        JSON.stringify(bodyObj)
                    ),
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Content-Encoding': 'gzip',
                    },
                }
            );

            return await response.json();
        } catch (error) {
            setInternalServerError(error);
        }
    }

    static async zip(bodyStr) {
        const compressed = new Response(bodyStr)
            .body
            .pipeThrough(
                // all usable browsers support gzip (12. 10. 2023)
                // eslint-disable-next-line no-undef
                new CompressionStream('gzip')
            );

        const bytes = await new Response(compressed)
            .arrayBuffer();

        return new Uint8Array(bytes);
    }
}

export default Request;